(function($) {

    let _codeLang = 'EN';

    let _lang = $('html').attr('lang');

    const _langArray = _lang.split("-");
    _lang = _langArray[1];

    switch (_lang) {
        case 'EN':
            _codeLang = 'EN';
            break;
        case 'FR':
            _codeLang = 'FR';
            break;
        case 'DE':
            _codeLang = 'GER';
            break;
        case 'ES':
            _codeLang = 'SP';
            break;
        case 'IT':
            _codeLang = 'IT';
            break;
        default:
            _codeLang = 'EN';
    }

    $('#newsletter .mc4wp-form-fields input[name="LANGUAGE"]').val(_codeLang);


})(jQuery);